import { useQuery } from "@tanstack/react-query";

import queries from "@/queries";

export default function useTablesTaggingStatus({
  workbookId,
  enabled = true,
}: {
  workbookId?: string | null;
  enabled?: boolean;
}) {
  return useQuery({
    ...queries.workbook(workbookId!)._ctx.tablesTaggingStatus(),
    enabled: !!workbookId && enabled,
    gcTime: 0,
    staleTime: 0,
  });
}
